module.exports = __webpack_public_path__ + "static/top_mockup-31ac8c3a50aed28b33d12a117405ce09.png";